import React from "react";
import { Modal } from "react-bootstrap";
import { BoxArrowLeft } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { LogoutModalProps } from "./LogoutModal.types.tsx";

import { GreenLabel, HeaderLabel, HelpLabel } from "../../components/Labels.tsx";
import { ActionButton } from "../../components/Buttons.tsx";

const LogoutModal: React.FC<LogoutModalProps> = ({ show, handleClose, handleLogout }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 d-flex flex-column align-items-center text-center">
        <BoxArrowLeft className="mb-3" size={30} />

        <HeaderLabel>{t("logoutModal.title")}</HeaderLabel>

        <HelpLabel>{t("logoutModal.description")}</HelpLabel>

        <div className="d-flex justify-content-evenly w-100 mt-3 buttonsContainer">
          <GreenLabel margin="0" onClick={handleClose}>
            {t("logoutModal.cancel")}
          </GreenLabel>

          <ActionButton width="30%" backgroundColor="#E20707" onClick={handleLogout}>
            {t("logoutModal.confirm")}
          </ActionButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
